import React, { Fragment } from "react";
import { NonIdealState, Button, Intent } from "@blueprintjs/core";
import { base } from "./../../../../fire";
import OpenFeedback from "../Feedback/Open";
import CloseFeedback from "../Feedback/Close";
import Participant from "../../../../services/Participant";
import StepConclusion from "../Steps/Conclusion";
import logo from "../../../../assets/logo.png";
import { translate } from "utlis/translations/i18n";

class PlayerFeedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentFeedback: null,
      isConcluding: true,
      feedbacksFilled: false,
    };
  }

  getParticipantResult = () => {
    const { session, instance } = this.props;
    const { feedbackAnswers = {} } = instance;
    const participantId = Participant.getParticipantIdBySessionId(session.id);

    return feedbackAnswers[participantId];
  };

  handleNextFeedback = () => {
    if (this.isLast()) return;
    this.setState((prevState) => {
      ++prevState.currentFeedback;
      return prevState;
    });
  };

  handlePrevFeedback = () => {
    if (this.isFirst()) return;
    this.setState((prevState) => {
      --prevState.currentFeedback;
      return prevState;
    });
  };

  onFinishConclusion = () => {
    this.setState({ isConcluding: false });
  };

  handleConfirmAnswer = (value = null, feedbackId) => {
    const { session, instance } = this.props;
    // const feedbackId = feedbacks[currentFeedback].id;

    base.post(
      `sessionInstances/${session.id}/${
        instance.id
      }/feedbackAnswers/${Participant.getParticipantIdBySessionId(
        session.id
      )}/${feedbackId}`,
      { data: value }
    );
  };

  //Gestion des feedbacks vide (cas où le participant "passe" le feedback sans répondre)
  submitFeedbacks = () => {
    const { feedbacks = [] } = this.props.session.data;
    // Récupère les réponses du participant et assure un objet vide par défaut
    const results = this.getParticipantResult() ?? {}; 
  
    feedbacks.forEach(feedback => {
      // Vérifiez si une réponse existe pour ce feedback
      const answer = results[feedback.id];
      if (!answer) {
        // Si aucune réponse, envoie une valeur par défaut à la base de données
        this.handleConfirmAnswer(translate("didNotAnswer"), feedback.id);
      }
    });
    // Marquer que tous les feedbacks ont été "remplis" pour cet utilisateur
    this.setState({ feedbacksFilled: true });
  };

  isFirst = () => this.setState({ feedbacksResults: true });

  isLast = () =>
    this.state.currentFeedback === this.props.session.data.feedbacks.length - 1;

  render() {
    const chainedSession = this.props.chainedSession;
    let link = "";
    if (chainedSession) {
      if (!link.startsWith("http://") && !link.startsWith("https://")) {
        link = "https://" + chainedSession;
      }
    }
    const { currentFeedback, isConcluding } = this.state;
    const { session } = this.props;
    const { data } = session;
    const { feedbacks = [], conclusions = [] } = data;
    const results = this.getParticipantResult() || {};    

    if (
      currentFeedback == null &&
      conclusions.length > 0 &&
      isConcluding &&
      this.props.type === "AUTONOMOUS"
    ) {
      return (
        <StepConclusion
          session={session}
          instance={this.props.instance}
          currentConclusion={this.props.currentConclusion}
          onNextConclusion={this.props.onNextConclusion}
          onPrevConclusion={this.props.onPrevConclusion}
          onFinishConclusion={this.onFinishConclusion}
        />
      );
      // conclusions.map((conclusion, i) => <h1 key={i}>{conclusion.name}</h1>)
    }

    if (feedbacks && feedbacks.length > 0 && !this.state.feedbacksFilled) {
      return (
        <Fragment>
          <div className="margin-top-large">
            {feedbacks.map((feedback, i) => {
              return (
                <div
                  className="col-xs-12 col-md-6 col-md-offset-3 margin-bottom-large feedback-container"
                  key={i}
                >
                  <div className="feedback-wrapper">
                    <div className="content">
                      {(!feedback.type || feedback.type === "OPEN") && (
                        <OpenFeedback
                          {...feedback}
                          answer={results[feedback.id]}
                          onConfirmAnswer={this.handleConfirmAnswer}
                        />
                      )}
                      {feedback.type && feedback.type !== "OPEN" && (
                        <CloseFeedback
                          {...feedback}
                          answer={results[feedback.id]}
                          onConfirmAnswer={this.handleConfirmAnswer}
                        />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="text-center">
            <Button
              rightIcon="double-chevron-right"
              intent={Intent.SUCCESS}
              // className='large-button'
              text={translate("finish")}
              onClick={this.submitFeedbacks}
            />
          </div>
          <div className="logo-container-bottom-left">
            <img src={logo} alt="logo" className="logo-large" /> &nbsp; &nbsp;
            <div>
              <span className="logo-title-large">VisualSense</span> <br />
              <span>&nbsp; Lyon, France</span>
            </div>
          </div>
        </Fragment>
      );
    }

    if (this.state.feedbacksFilled === true)
      return (
        <Fragment>
          <NonIdealState
            className="margin-top-x-large"
            title={translate("thanksForParticipation")}
            description={translate("youFinishedSession")}
            action={
              feedbacks.length !== 0 && (
                <Fragment>
                  <Button
                    text={translate("modifyFeedback")}
                    intent={Intent.PRIMARY}
                    onClick={() => {
                      this.setState({ feedbacksFilled: false });
                    }}
                  />
                  {chainedSession && (
                    <Button
                      style={{
                        display: "block",
                        marginTop: "20px",
                        marginRight: "auto",
                        marginLeft: "auto",
                      }}
                      text={translate("goToNextSession")}
                      intent={Intent.PRIMARY}
                      onClick={() => {
                        window.location.href = link;
                      }}
                    />
                  )}
                </Fragment>
              )
            }
            icon="endorsed"
          />
          <div className="logo-container-bottom-left">
            <img src={logo} alt="logo" className="logo-large" /> &nbsp; &nbsp;
            <div>
              <span className="logo-title-large">VisualSense</span> <br />
              <span>&nbsp; Lyon, France</span>
            </div>
          </div>
        </Fragment>
      );
    // feedback = feedbacks[currentFeedback];

    return (
      <Fragment>
        <NonIdealState
          className="margin-top-x-large"
          title={translate("thanksForParticipation")}
          description={translate("youFinishedSession")}
          icon="endorsed"
        />
        {chainedSession && (
          <Button
            style={{
              display: "block",
              marginTop: "20px",
              marginRight: "auto",
              marginLeft: "auto",
            }}
            text={translate("goToNextSession")}
            intent={Intent.PRIMARY}
            onClick={() => {
              window.location.href = link;
            }}
          />
        )}
        <div className="logo-container-bottom-left">
          <img src={logo} alt="logo" className="logo-large" /> &nbsp; &nbsp;
          <div>
            <span className="logo-title-large">VisualSense</span> <br />
            <span>&nbsp; Lyon, France</span>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default PlayerFeedback;
